// extracted by mini-css-extract-plugin
export default {"new-option-button":"phrase-search_new-option-button__p3i6J","remove-option-button":"phrase-search_remove-option-button__k2V7Y","row-group-item":"phrase-search_row-group-item__VCNQq"};